import { Badge } from "@/components/ui/badge";
import { useLocale } from "@/hooks/useLocale";
import { User, BookOpen, Database, Tag } from "lucide-react";

interface WorldStats {
  entities: number;
  characters: number;
  scenarios: number;
  tags: string[];
}

export function WorldStatsRow({ stats }: { stats?: WorldStats }) {
  const { t } = useLocale();
  if (!stats) return null;
  const { entities, characters, scenarios, tags } = stats;
  if (entities === 0 && scenarios === 0 && tags.length === 0) return null;
  return (
    <div data-slot="world-stats" className="space-y-1.5">
      <div className="flex items-center gap-3 text-[11px] text-muted-foreground">
        {characters > 0 && (
          <span className="flex items-center gap-1"><User className="w-3 h-3" />{characters} {t.idx_characters}{characters !== 1 ? (t.idx_characters === "character" ? "s" : "") : ""}</span>
        )}
        {scenarios > 0 && (
          <span className="flex items-center gap-1"><BookOpen className="w-3 h-3" />{scenarios} {t.idx_scenarios}{scenarios !== 1 ? (t.idx_scenarios === "scenario" ? "s" : "") : ""}</span>
        )}
        {entities > 0 && (
          <span className="flex items-center gap-1"><Database className="w-3 h-3" />{entities} {t.idx_entities}{entities !== 1 ? (t.idx_entities === "entity" ? "ies" : "") : (t.idx_entities === "entity" ? "" : "")}</span>
        )}
      </div>
      {tags.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {tags.map((tag) => (
            <Badge key={tag} variant="outline" className="text-[9px] px-1.5 py-0 h-4 font-normal text-muted-foreground">
              {tag}
            </Badge>
          ))}
        </div>
      )}
    </div>
  );
}
